import React from "react";
import {
  consumeApi,
  getTokens,
  setLiteral,
  validateEmail,
  setLiteral2,
  setLiteral3,
} from "../js/helpers.js";
import Framework7, { Dom7, getDevice } from "framework7";
import {
  Page,
  f7,
  Link,
  LoginScreen,
  Block,
  Button,
  Row,
  NavLeft,
  Col,
  LoginScreenTitle,
  List,
  ListInput,
} from "framework7-react";
import packageJson from "../../package.json";
import "../css/NLogin.css";
import ReferenciaUnica from "./referenciaUnica";
import ReferenciaUnicaConekta from "./referenciaUnicaConekta.jsx";
export default class NewLogin extends React.Component {
  render() {
    return (
      /*-----------------------------LOGIN------------------------------------------*/
      <Page name="home" className="mainImg">
        {this.renderSection(this.state.selectedTab)}
      </Page>
    );
  }

  state = {
    height: 0,
    heightFeatures: 0,
    selectedTab: 1,
    username: "",
    password: "",
    hideEmail: "",
    loginScreenOpened: false,
    configDomain: "",
    configMiApp: "",
    lsLiterales: "",
    idEmpresa: "",
    popupRegistro: "",
    popupUser: false,
    bValidatePass: false,
    sPass: "",
    sTextPass: "",
    Identification: "",
    userInformation: "",
    bSamePass: false,
    popupPassword: false,
    showCloseLogin: "",
    RU: {},
    companyReference: "",
  };

  $$ = Dom7;
  f7router = "";

  caching = () => {
    let version = localStorage.getItem("version");
    if (version != packageJson.version) {
      if ("caches" in window) {
        caches.keys().then((names) => {
          // Delete all the cache files
          names.forEach((name) => {
            caches.delete(name);
          });
        });
        // Makes sure the page reloads. Changes are only visible after you refresh.
        window.location.reload(true);
      }

      localStorage.clear();
      localStorage.setItem("version", packageJson.version);
    }
  };

  componentDidMount = () => {
    const { f7route, f7router } = this.props;
    const params = f7route.query;

    if (params.page && params.page == "refunica") {
      this.loadReferenciaUnica(params);
    } else {
      this.loadNormalMiapp(params);
    }

    this.caching();
  };

    renderSection = (tab) => {
    switch (tab) {
      case 1:
      default:
        return  <LoginScreen className="LOGIN" opened>
          <LoginScreenTitle className="MC">
            {setLiteral(this.state.lsLiterales, 101092)}
            {/* Bienvenido a <a>MI CUOTA FÁCIL</a> */}
            <h2 id="">{setLiteral(this.state.lsLiterales, 101023)}</h2>
            <Block></Block>
            <div id="Registro">
              {setLiteral(this.setState.lsLiterales, 101123)}
              <Link
                className="aligner2 Regist"
                onClick={() => {
                  this.props.f7router.navigate("/Register", {
                    lsLiterales: this.setState.lsLiterales,
                  });
                }}
              >
                {setLiteral(this.state.lsLiterales, 101028)}
              </Link>
            </div>
          </LoginScreenTitle>
          <List form>
            <Row className="aligner2">
              <Col
                width="90"
                xlarge="95"
                large="65"
                medium="65"
                small="90"
                xsmall="90"
              >
                <ListInput
                  id="txtUsername"
                  className="inputCustom"
                  outline
                  label={setLiteral2(this.state.lsLiterales, 101024)}
                  placeholder={setLiteral(this.state.lsLiterales, 101024)}
                  type="text"
                  onChange={(e) => this.setState({ username: e.target.value })}
                  value={this.state.username}
                ></ListInput>
              </Col>
              <Col width="10"></Col>
            </Row>
            <Row className="aligner2">
              <Col
                width="90"
                xlarge="95"
                large="65"
                medium="65"
                small="90"
                xsmall="90"
              >
                <ListInput
                  id="passwordLogin"
                  outline
                  label={setLiteral2(this.state.lsLiterales, 101025)}
                  placeholder={setLiteral3(this.state.lsLiterales, 101025)}
                  className="inputCustom"
                  onChange={(e) => this.setState({ password: e.target.value })}
                  type="password"
                  name="passwordLogin"
                ></ListInput>
              </Col>
              <Col
                width="10"
                xlarge="5"
                large="10"
                medium="10"
                small="5"
                xsmall="5"
              >
                <Button
                  id="btnShowPassRegister2"
                  iconF7="eye_slash"
                  className="btnPass"
                  onClick={() =>
                    this.showPassword("passwordLogin", "btnShowPassRegister2")
                  }
                ></Button>
              </Col>
            </Row>

            <Row className="aligner3_2">
              <Col
                width="100"
                xlarge="50"
                large="50"
                medium="50"
                small="100"
                xsmall="100"
              >
                <Link href="/Validate">
                  {setLiteral(this.state.lsLiterales, 101026)}
                </Link>
              </Col>
            </Row>

            <Block>
              <Row className="aligner3">
                <Col width="100" xlarge="50">
                  <Button
                    className="BtnLogin"
                    fill
                    onClick={async () =>
                      this.validateUser(
                        this.state.username,
                        this.state.password
                      )
                    }
                  >
                    {setLiteral(this.state.lsLiterales, 101027)}
                  </Button>
                </Col>
              </Row>
            </Block>
          </List>
          <Block></Block>
        </LoginScreen>;
      
      case 5:
        return this.renderReferenciaUnica();
    }
  };
    renderReferenciaUnica = () => {
      return this.state.companyReference === "436" ? (
        <ReferenciaUnicaConekta RU={this.state.RU} />
      ) : (
        
        <ReferenciaUnica RU={this.state.RU} />
      );
    };
  loadReferenciaUnica = async (params) => {
      if (params.companyid) {
        this.$$("body").addClass("color-theme-" + params.companyid);
        this.$$("body").addClass("ruStyle");
        await getTokens(parseInt(params.companyid));
      }
  
      f7.dialog.preloader();
      
      const method =
        "/core/Payment/PaymentReferenceUnique/" +
        params.contractid +
        "/" +
        params.companyid;
      let uniqueReference = await consumeApi("get", method, "");
  
      if (!String(uniqueReference).includes("error")) {
        if (params.companyid != "436")
          uniqueReference = uniqueReference.find(
            (item) =>
              item.provider.toUpperCase() === "ENEFEVO" ||
              item.provider.toUpperCase() === "CONEKTA"
          );
        this.setState({ RU: uniqueReference });
      }
  
      f7.dialog.close();
  
      this.setState({
        selectedTab: 5,
        companyReference: params.companyid,
      });
    };

  loadNormalMiapp = (params) => {
    const { f7route, f7router } = this.props;

    const device = getDevice();
    if (device.android || device.ios) {
      //this.setState({ closeLogin: 'hide' });
    }

    if (window.innerWidth < 800 && this.props.reload) window.location.reload();

    this.f7router = f7router;

    const height = parseInt(window.innerHeight * 0.6) + "px";
    const heightFeatures = parseInt(window.innerHeight * 0.8) + "px";
    this.getConfiguration(params);
    this.setState({ height: height, heightFeatures: heightFeatures });
  };
  sendSMS = async (telephone) => {
    f7.dialog.preloader("");

    const method =
      "/core/Contract/ContractByClientId/" +
      this.state.configDomain.id_empresa +
      "/" +
      this.state.userInformation.clientId;
    const contracts = await consumeApi("get", method, "");

    var nup = "";

    if (typeof contracts == "object" && contracts.length > 0) {
      contracts[0].contractCode;
      nup = contracts[0].contractCode.split("N")[1];
    }

    const methodPass = "/miapp/User/SmsSend";
    const params = JSON.stringify({
      company: this.state.configDomain.id_empresa,
      language: this.state.configDomain.id_idioma,
      clientId: this.state.userInformation.clientId,
      login: this.state.userInformation.login,
      telephone: telephone,
      typeSms: "2",
      application_id: nup,
      applicationType: "1",
    });

    const insSms = await consumeApi("POST", methodPass, params);
    f7.dialog.close();
    if (!insSms.includes("error")) {
      this.validateSMS();
    }
  };
  getConfiguration = async (params) => {
    const sHost = window.location.hostname;
    const method = "/security/InfoDomain/ConfigByDomain/" + sHost;

    const configuration = await consumeApi("GET", method, "");
    //configuration.id_empresa = "603";
    //configuration.id_idioma = "C";

    await getTokens(parseInt(configuration.id_empresa));

    this.$$("body").addClass("color-theme-" + configuration.id_empresa);

    this.setState({ configDomain: configuration });

    this.getLiterales();
    this.getConfigMiAppByBranch();

    if (
      params.company &&
      params.idpago &&
      params.idprovider &&
      params.email &&
      params.test &&
      params.cancellation
    ) {
      this.paymentOnline(
        params.company,
        params.idpago,
        params.idprovider,
        params.email,
        params.test,
        params.cancellation
      );
    }

    if (this.props.f7route.query.IdCliente) {
      this.getUserByClientId(this.props.f7route.query.IdCliente);
    }
  };

  paymentOnline = async (
    company,
    paymentId,
    provider,
    email,
    test,
    cancellation
  ) => {
    f7.dialog.preloader();
    const url =
      "/notification/Emails/CreateLinkPago/" +
      company +
      "/" +
      paymentId +
      "/" +
      provider +
      "/" +
      test +
      "/" +
      email +
      "/" +
      this.state.configDomain.id_idioma +
      "/" +
      cancellation;

    const result = await consumeApi("GET", url, "");

    if (!result.includes("error")) {
      f7.dialog.close();
      window.location.replace(result);
    } else if (result.includes("Invalid payment")) {
      f7.dialog.close();
      f7.dialog.alert(
        "Su link de pago ya no es válido, favor de solicitar otro",
        "Link inválido"
      );
    }
  };

  getLiterales = async () => {
    f7.dialog.preloader(setLiteral(this.state.lsLiterales, 101030));
    const method =
      "/miapp/MiApp/Literal/" +
      this.state.configDomain.id_empresa +
      "/" +
      this.state.configDomain.id_idioma;

    const lsLiterales = await consumeApi("GET", method, "");
    this.setState({ lsLiterales: lsLiterales });
    f7.dialog.close();
  };

  getConfigMiAppByBranch = async () => {
    const method =
      "/miapp/MiApp/ConfigurationByBranch/" +
      this.state.configDomain.id_empresa;
    const lsLiterales = await consumeApi("GET", method, "");
    this.setState({ configMiApp: lsLiterales });
  };

  validateUser = async (username, password) => {
    const method = "/miapp/User/ValidateUser";

    if (validateEmail(username)) username = username.toUpperCase();

    const params = JSON.stringify({
      company: this.state.configDomain.id_empresa,
      login: username,
      password: password,
      applicationType: "1",
    });

    const login = await consumeApi("POST", method, params);

    if (login.clientId != "" && login.active == "1") {
      this.f7router.navigate("/HomeInsdide/", {
        props: {
          lsLiterales: this.state.lsLiterales,
          user: login,
          configDomain: this.state.configDomain,
          configMiApp: this.state.configMiApp,
        },
      });
    } else if (login.active == "0") {
      this.setState({ userInformation: login });
      this.sendSMS();
    } else {
      if (login.includes("Not found data") || login.includes("error")) {
        f7.dialog.alert(setLiteral(this.state.lsLiterales, 101029), "");
      }
    }
  };

  showPassword = (nameInput, nameButton) => {
    var input = this.$$('input[name="' + nameInput + '"]');
    if (input.attr("type") == "password") {
      input.attr("type", "text");
      this.$$("#" + nameButton + "")
        .children(".icon")
        .html("eye");
    } else {
      input.attr("type", "password");
      this.$$("#" + nameButton + "")
        .children(".icon")
        .html("eye_slash");
    }
  };

  validateSMS = async () => {
    f7.dialog
      .create({
        title: setLiteral(this.state.lsLiterales, 101053),
        text:
          "<div>" +
          setLiteral(this.state.lsLiterales, 101054) +
          ' </br><div class="textCenter">' +
          setLiteral(this.state.lsLiterales, 101055) +
          '</div><input id="inSMS" type="text" class="dialog-input"></input>' +
          "</div>",
        buttons: [
          {
            text: setLiteral(this.state.lsLiterales, 101060),
            onClick: async () => {
              if (Dom7("#inSMS").val() == "") {
                f7.dialog.alert(setLiteral(this.state.lsLiterales, 101061), "");
                this.validateSMS();
              } else {
                const value = Dom7("#inSMS").val();

                const methodValidate = "/miapp/User/CustomerBySms";

                const params = JSON.stringify({
                  company: this.state.configDomain.id_empresa,
                  clientId: this.state.userInformation.clientId,
                  sms: value,
                  option: "2",
                  applicationType: "1",
                });

                const insSms = await consumeApi("POST", methodValidate, params);
                if (!insSms.includes("error")) {
                  const methodActive = "/miapp/User/UpdateSmsUser";

                  const params = JSON.stringify({
                    company: this.state.configDomain.id_empresa,
                    clientId: this.state.userInformation.clientId,
                    sms: value,
                    status: "1",
                    applicationType: "1",
                  });

                  const activeSms = await consumeApi(
                    "POST",
                    methodActive,
                    params
                  );
                  if (!activeSms.includes("error")) {
                    this.setState({
                      loginScreenOpened: true,
                      popupUser: false,
                      popupPassword: false,
                    });
                    f7.dialog.close();
                    f7.dialog.alert("¡Éxito!");
                  }
                } else {
                  f7.dialog.alert(
                    setLiteral(this.state.lsLiterales, 101056),
                    ""
                  );
                  this.validateSMS();
                }
              }
            },
          },
          {
            text: setLiteral(this.state.lsLiterales, 101097),
            onClick: () => {
              var tel = "";
              if (this.state.userInformation.personalPhone)
                tel = this.state.userInformation.personalPhone;
              else if (this.state.userInformation.telephone)
                tel = this.state.userInformation.telephone;

              this.sendSMS(tel);
            },
          },
        ],
      })
      .open();
  };
}
